export const getFileType = (file) => {
  return file.split('.').pop().toLowerCase()
}
